<div class="container mt-4">
    <div *ngIf="slideLoadStatus" class="alert alert-info py-2 small mb-3 d-flex align-items-center gap-2" role="status">
        <span class="spinner-border spinner-border-sm" *ngIf="slideGenerating" aria-hidden="true"></span>
        <span>{{ slideLoadStatus }}</span>
    </div>
    <form [formGroup]="slideForm">

        <!-- Slide Info -->
        <div class="card mb-3">
            <div class="card-body">

                <div class="mb-3">
                    <label class="form-label">Slide Title</label>
                    <input type="text" class="form-control" formControlName="slideTitle">
                </div>

                <div class="mb-3">
                    <label class="form-label">Slide Type</label>
                    <select class="form-select" formControlName="slideType">
                        <option value="">-- Select Slide Type --</option>
                        <option *ngFor="let type of slideTypes" [value]="type.code">
                            {{ type.code }} : {{ type.label }}
                        </option>
                    </select>
                </div>

                <div class="mb-3">
                    <label class="form-label">Opening Note</label>
                    <textarea class="form-control" rows="2" formControlName="openingNote"></textarea>
                </div>

                <div class="mb-3">
                    <label class="form-label">Closing Note</label>
                    <textarea class="form-control" rows="2" formControlName="closingNote"></textarea>
                </div>

            </div>
        </div>

        <!-- Elements Table -->
        <div class="card">
            <div class="card-header d-flex justify-content-between">
                <span>Slide Elements</span>
                <button type="button" class="btn btn-sm btn-primary" (click)="addElement()" [disabled]="slideGenerating">
                    Add Element
                </button>
            </div>

            <div class="card-body table-responsive">
                <table class="table table-bordered align-middle">
                    <thead class="table-light">
                        <tr>
                            <th>Type</th>
                            <th>Bullet</th>
                            <th>Indent</th>
                            <th>Content</th>
                            <th>Notes</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody formArrayName="slideElements">
                        <tr *ngFor="let element of slideElements.controls; let i = index" [formGroupName]="i">

                            <!-- Element Type -->
                            <td style="width: 8%;">
                                <select class="form-select" formControlName="elementType">
                                    <option *ngFor="let type of elementTypes" [value]="type">
                                        {{ type }}
                                    </option>
                                </select>
                            </td>



                            <!-- Bullet Flag (TEXT only) -->
                            <td style="width: 6%;">
                                <ng-container *ngIf="isText(i)">
                                    <select class="form-select" formControlName="bulletFlag">
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </ng-container>
                            </td>

                            <!-- Indent Level (TEXT only) -->
                            <td style="width: 6%;">
                                <ng-container *ngIf="isText(i)">
                                    <input type="number" class="form-control" min="0" formControlName="indentLevel">
                                </ng-container>
                            </td>
                            <!-- Content -->
                            <td style="width: 35%;">

                               <textarea
  class="form-control"
  formControlName="content"
  rows="1"
  style="resize: vertical;"
  (input)="autoGrow($event)">
</textarea>
                            </td>
                            <!-- Notes -->
                            <td style="width: 35%;">
                                <textarea
  class="form-control"
  formControlName="notes"
  rows="1"
  style=" resize: vertical;"
  (input)="autoGrow($event)">
</textarea>

                            </td>

                            <!-- Actions -->
                            <td style="width: 12%;">
                                <div class="btn-group flex-wrap">
                                    <button type="button" class="btn btn-sm btn-secondary"
                                        (click)="moveUp(i)">↑</button>

                                    <button type="button" class="btn btn-sm btn-secondary"
                                        (click)="moveDown(i)">↓</button>

                                    <button type="button" class="btn btn-sm btn-success"
                                        (click)="insertElement(i)">+</button>

                                    <button type="button" class="btn btn-sm btn-danger"
                                        (click)="deleteElement(i)">✕</button>
                                </div>
                                <button
                                    *ngIf="isImage(i)"
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary mt-1"
                                    (click)="regenerateImageAt(i)"
                                    [disabled]="slideGenerating || regeneratingImageIndex != null"
                                >
                                    {{ regeneratingImageIndex === i ? 'Regenerating…' : 'Regenerate image' }}
                                </button>
                            </td>

                        </tr>
                    </tbody>

                </table>
            </div>
        </div>

        <!-- Save Button -->
         <div class="text-start mt-3">
            <button type="button" class="btn btn-lg btn-primary" (click)="gotoTOC()" [disabled]="slideGenerating">
                {{ slideGenerating ? 'Generating…' : 'Go to TOC' }}
            </button>
        </div>
        <div class="text-end mt-3">
            <button type="button" class="btn btn-lg btn-primary" (click)="saveSlide()" [disabled]="slideGenerating">
                Save Slide
            </button>
        </div>

    </form>
</div>